import { useTranslation } from "react-i18next";
import { useXlsImporterSettings } from "@tools";
import { Grid, Step, StepButton, Stepper } from "@material-ui/core";
import useStyle from "./ImporterStepper.style";

export const ImporterStepper = () => {
  const classes = useStyle();
  const { t } = useTranslation();
  const settings = useXlsImporterSettings();

  const { steps, activeStep } = settings;

  return (
    <Grid
      item container
      justifyContent="center"
    >
      <Stepper
        nonLinear
        className={classes.stepper}
        activeStep={activeStep}
      >
        {
          steps.map(({ locked, completed, id }, i) => (
            <Step key={id}>
              <StepButton
                completed={!locked && completed}
                disabled={locked}
                onClick={() => settings.handleActiveStepChange(i)}
              >
                {t(`views.import.steps.${id}`)}
              </StepButton>
            </Step>
          ))
        }
      </Stepper>
    </Grid>
  );
};
